import apiFetch from '../apiFetch'

export default function (idSeguimiento) {
  return apiFetch({endPoint: `Seguimiento/getSeguimiento?idSeguimiento=${idSeguimiento}`, method: 'GET', body: null})
}
